"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DraggableHandItem_1 = __importDefault(require("./DraggableHandItem"));
var HandItem_1 = __importDefault(require("./HandItem"));
function Hand(_a) {
    var children = _a.children, _b = _a.maxAngle, maxAngle = _b === void 0 ? 15 : _b, _c = _a.gapMaxAngle, gapMaxAngle = _c === void 0 ? 3 : _c, _d = _a.clockwise, clockwise = _d === void 0 ? true : _d, getItemProps = _a.getItemProps, props = __rest(_a, ["children", "maxAngle", "gapMaxAngle", "clockwise", "getItemProps"]);
    var items = react_1.Children.toArray(children).filter(function (child) { return !!child; });
    var itemsProps = items.map(function (_, index) { var _a; return (_a = getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps(index)) !== null && _a !== void 0 ? _a : {}; });
    var totalItems = itemsProps.filter(function (itemProps) { return !(itemProps === null || itemProps === void 0 ? void 0 : itemProps.ignore); }).length;
    var nearbyRotation = items.length > 1 ? Math.min(maxAngle / (items.length - 1), gapMaxAngle) * (clockwise ? 1 : -1) : 0;
    var handItems = [];
    var previousItems = 0;
    for (var index = 0; index < items.length; index++) {
        var _e = itemsProps[index], ignore = _e.ignore, itemProps = __rest(_e, ["ignore"]);
        var angle = ignore ? 0 : (previousItems - (totalItems - 1) / 2) * nearbyRotation;
        var child = items[index];
        var key = hasKey(child) ? child.key : index;
        if (itemProps === null || itemProps === void 0 ? void 0 : itemProps.drag) {
            handItems.push(jsx_runtime_1.jsx(DraggableHandItem_1.default, __assign({ angle: angle, drag: itemProps === null || itemProps === void 0 ? void 0 : itemProps.drag }, props, itemProps, { children: child }), key));
        }
        else {
            handItems.push(jsx_runtime_1.jsx(HandItem_1.default, __assign({ angle: angle }, props, itemProps, { children: child }), key));
        }
        if (!ignore) {
            previousItems++;
        }
    }
    return jsx_runtime_1.jsx(react_1.Fragment, { children: handItems }, void 0);
}
exports.default = Hand;
function hasKey(child) {
    return child.key != undefined;
}
//# sourceMappingURL=Hand.js.map